import { useEffect, useState } from "react";

export function useGeolocation() {
  const [location, setLocation] = useState<{ lat: number; lon: number } | null>(
    null,
  );
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!("geolocation" in navigator)) {
      setError("Geolocation not supported by this browser");
      setLoading(false);
      return;
    }

    let attempts = 0;

    function getLocation() {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          setLocation({
            lat: pos.coords.latitude,
            lon: pos.coords.longitude,
          });
          setError(null);
          setLoading(false);
        },
        (err) => {
          console.log(err);
          if (err.code === err.POSITION_UNAVAILABLE && attempts < 3) {
            attempts++;
            console.warn("Retrying location, attempt", attempts);
            setTimeout(getLocation, 3000); // retry after 2s
          } else {
            setError(err.message);
            setLoading(false);
          }
        },
      );
    }

    getLocation();
  }, []);

  return { location, loading, error };
}
